(() => {
  if (customElements.get('water-report')) return;

  const API_GEO = 'https://geo.api.gouv.fr/communes';
  const API_NETWORKS = 'https://hubeau.eaufrance.fr/api/v1/qualite_eau_potable/communes_udi';
  const API_RESULTS = 'https://hubeau.eaufrance.fr/api/v1/qualite_eau_potable/resultats_dis';
  const MAX_RESULT_ROWS = 20000;
  const PAGE_SIZE = 5000;
  const REQUEST_TIMEOUT = 15000;
  const RESULT_FIELDS = [
    'code_prelevement',
    'code_parametre',
    'code_parametre_se',
    'libelle_parametre',
    'libelle_parametre_maj',
    'libelle_parametre_web',
    'code_type_parametre',
    'resultat_alphanumerique',
    'resultat_numerique',
    'libelle_unite',
    'limite_qualite_parametre',
    'reference_qualite_parametre',
    'date_prelevement',
    'conformite_limites_bact_prelevement',
    'conformite_limites_pc_prelevement',
    'nom_distributeur',
    'reseaux',
  ].join(',');

  const DEFAULT_LABELS = {
    postcode_label: 'Code postal à 5 chiffres',
    postcode_placeholder: 'Votre code postal — ex. 06000',
    search_button: 'Voir mon eau',
    search_loading: 'Analyse en cours…',
    examples_label: 'Essayez :',
    commune_heading: 'Choisissez votre commune.',
    network_heading: 'Choisissez votre réseau.',
    loading_communes: 'Recherche de votre commune…',
    loading_networks: 'Identification du réseau d’eau…',
    loading_results: 'Lecture des dernières analyses publiées…',
    loading_step_commune: 'Recherche de la commune',
    loading_step_network: 'Identification du réseau',
    loading_step_results: 'Analyse des données',
    reset: 'Nouvelle recherche',
    email_label: 'Votre adresse email',
    email_placeholder: 'votre@email.fr',
    gate_button: 'Débloquer mon rapport',
    gate_saving: 'Enregistrement…',
    gate_success: 'Votre inscription est confirmée. Le rapport est maintenant disponible.',
    gate_error: 'Impossible de confirmer votre inscription pour le moment. Réessayez.',
    preview_bypass: 'Prévisualiser sans Klaviyo',
    report_location_prefix: 'L’eau du robinet à',
    status_context: 'Statut du dernier contrôle',
    coverage_short_label: 'Sous les limites',
    coverage_detail_label: 'paramètres comparables respectent leur limite',
    coverage_na: 'N/A',
    coverage_na_detail: 'Aucune limite comparable disponible sur la période',
    overview_exceeded: 'Au-dessus de la limite',
    overview_within: 'Dans les limites',
    overview_quantified: 'Substances quantifiées',
    detected_singular: 'substance quantifiée',
    detected_plural: 'substances quantifiées',
    contrast_heading: 'Conforme aux limites, mais...',
    contrast_body:
      'Chaque affirmation peut être vraie en même temps. La conformité réglementaire rassure, mais elle ne veut pas dire concentration nulle ni analyse de tout ce qui pourrait être présent.',
    contrast_limits_yes: 'Les paramètres comparables respectent les seuils applicables.',
    contrast_but: 'mais',
    contrast_limits_but_prefix: 'un seuil n’est pas zéro :',
    contrast_limits_but_suffix: 'sont présentes à une concentration mesurable.',
    contrast_limits_but_suffix_zero: 'n’ont été relevées dans les dernières valeurs disponibles.',
    contrast_scope_yes: 'Le contrôle sanitaire couvre de nombreux paramètres.',
    contrast_scope_but:
      'paramètres ont été examinés sur la période, selon le programme de contrôle publié pour ce réseau.',
    contrast_microplastics_yes: 'Les résultats officiels affichent ce qui a été recherché.',
    contrast_microplastics_not_tested: 'Microplastiques non testés',
    contrast_microplastics_but: 'dans le contrôle de routine affiché ici.',
    contrast_zero_yes: 'Aucun dépassement affiché reste une bonne nouvelle.',
    contrast_zero_but:
      'au-dessus de la limite ne signifie pas que toutes les substances possibles sont absentes.',
    scope_heading: 'Ce que le rapport montre — et ce qu’il ne permet pas d’affirmer',
    scope_body:
      'Le rapport est utile parce qu’il relie chaque valeur à une source, une date et un réseau. Son périmètre reste celui du contrôle publié.',
    scope_microplastics_title: 'Microplastiques',
    scope_microplastics_body:
      'Non testés dans le contrôle de routine affiché ici. Ne pas les présenter comme absents.',
    scope_parameters_title: 'Liste de paramètres',
    scope_parameters_body:
      'Les paramètres analysés varient selon le réseau, la date et le type de contrôle sanitaire.',
    scope_snapshot_title: 'Prélèvement instantané',
    scope_snapshot_body:
      'Une valeur décrit un moment précis. Les concentrations peuvent évoluer avec les saisons et les traitements.',
    scope_experience_title: 'Goût, odeur, calcaire',
    scope_experience_body:
      'Ces gênes peuvent rester perceptibles même lorsque l’eau respecte les limites réglementaires.',
    scope_note:
      'Ce contenu informe et aide au choix d’une filtration complémentaire. Il ne transforme pas une eau conforme en eau dangereuse ou impropre.',
    latest_sample_label: 'Dernier prélèvement',
    sample_count_label: 'Prélèvements examinés',
    parameter_count_label: 'Paramètres examinés',
    measured_label: 'Mesuré',
    not_measured_label: 'Non mesuré sur la période',
    legal_limit_label: 'Limite réglementaire',
    limit_exceeded_label: 'Limite réglementaire dépassée',
    details_tabs_label: 'Filtrer les substances',
    details_all: 'Tous',
    details_substance_label: 'Substance',
    details_value_label: 'Valeur',
    details_status_label: 'Statut',
    details_status_measured: 'Quantifiée',
    details_status_over: 'Au-dessus de la limite',
    no_detected: 'Aucune substance réglementée quantifiée dans les dernières valeurs disponibles.',
    primary_label: 'Recommandation principale',
    view_product: 'Découvrir',
    inhabitants_label: 'habitants',
    network_fallback_label: 'Réseau',
    postcode_error: 'Entrez un code postal français à 5 chiffres.',
    geo_error: 'Le service de recherche des communes est indisponible. Réessayez dans un instant.',
    no_commune_error: 'Aucune commune trouvée pour ce code postal.',
    network_error: 'Impossible d’identifier le réseau d’eau de cette commune.',
    no_data_error: 'Aucun résultat publié sur la période sélectionnée pour ce réseau.',
    water_api_error: 'Les données du contrôle sanitaire sont momentanément indisponibles.',
    config_error: 'La clé publique Klaviyo doit être configurée avant de publier cette section.',
    consent_error: 'Vous devez accepter la communication par email pour ouvrir le rapport.',
    email_error: 'Entrez une adresse email valide.',
    report_error: 'Une erreur inattendue empêche l’affichage du rapport.',
    category_pfas: 'PFAS',
    category_pesticides: 'Pesticides et métabolites',
    category_metals: 'Métaux',
    category_disinfection: 'Sous-produits de désinfection',
    category_other: 'Autres substances',
    concern_chlorine: 'Chlore',
    concern_pfas: 'PFAS',
    concern_fluoride: 'Fluorures',
    concern_bacteriological: 'Non-conformité bactériologique',
    concern_pesticides: 'Pesticides',
    concern_metals: 'Métaux',
    concern_disinfection: 'Sous-produits de désinfection',
  };

  const PARAMETER_DEFINITIONS = {
    hardness: {
      title: 'Dureté (calcaire)',
      unit: '°f',
      match: /TITRE HYDROTIM|DURET[ÉE]?/i,
      scaleMax: 50,
      description:
        'La dureté est un paramètre de confort. Une eau dure peut favoriser les dépôts de tartre sans constituer une non-conformité sanitaire.',
    },
    chlorine: {
      title: 'Chlore libre',
      unit: 'mg/L',
      match: /CHLORE LIBRE/i,
      scaleMax: 1,
      description:
        'Le chlore protège le réseau contre les bactéries. Son goût et son odeur peuvent devenir perceptibles selon la concentration.',
    },
    nitrates: {
      title: 'Nitrates',
      unit: 'mg/L',
      match: /^NITRATES(?!.*NITRITES)/i,
      fallbackLimit: 50,
      scaleMax: 50,
      description:
        'Les nitrates proviennent notamment de l’activité agricole. La carte compare la dernière valeur disponible à la limite indiquée par les données officielles.',
    },
    pesticides_total: {
      title: 'Pesticides (total)',
      unit: 'µg/L',
      match: /TOTAL DES PESTICIDES|PESTICIDES TOTAUX|SOMME DES PESTICIDES/i,
      fallbackLimit: 0.5,
      scaleMax: 0.5,
      description:
        'Somme des pesticides et métabolites quantifiés lorsque ce paramètre agrégé est publié pour le réseau.',
    },
    pfas: {
      title: 'PFAS',
      unit: 'µg/L',
      match: /SOMME DES 20 PFAS|SOMME DE 20 PFAS|PFAS.*(?:SOMME|TOTAL)|TOTAL.*PFAS/i,
      fallbackLimit: 0.1,
      scaleMax: 0.1,
      description:
        'Les PFAS sont des substances très persistantes. Les résultats apparaissent progressivement selon les campagnes de contrôle disponibles.',
    },
    lead: {
      title: 'Plomb',
      unit: 'µg/L',
      match: /^PLOMB/i,
      fallbackLimit: 10,
      scaleMax: 10,
      description:
        'Le plomb peut notamment provenir d’anciennes canalisations. Une mesure sur le réseau ne décrit pas toujours les conduites privées du bâtiment.',
    },
    thm: {
      title: 'Trihalométhanes',
      unit: 'µg/L',
      match: /TRIHALOM[ÉE]THANES/i,
      fallbackLimit: 100,
      scaleMax: 100,
      description:
        'Les trihalométhanes sont des sous-produits pouvant se former lors de la désinfection de l’eau.',
    },
    cvm: {
      title: 'Chlorure de vinyle',
      unit: 'µg/L',
      match: /CHLORURE DE VINYLE/i,
      fallbackLimit: 0.5,
      scaleMax: 0.5,
      description:
        'Le chlorure de vinyle peut migrer depuis certaines anciennes canalisations en PVC. Il n’est pas mesuré dans chaque campagne.',
    },
  };

  const CATEGORY_DEFINITIONS = [
    {
      key: 'pfas',
      labelKey: 'category_pfas',
      match: /PFAS|PERFLUORO|POLYFLUORO|FLUOROTELOM|PFOA|PFOS|PFHXS|PFNA|PFBS|PFBA|PFHXA|PFHPA|PFDA/i,
    },
    {
      key: 'pesticides',
      labelKey: 'category_pesticides',
      match:
        /PESTICIDE|ATRAZINE|SIMAZINE|TRIAZINE|CHLOROTHALONIL|M[ÉE]TOLACHLOR|METAZACHLOR|ALACHLOR|AC[ÉE]TOCHLOR|GLYPHOSATE|AMPA\b|BENTAZONE|DIURON|ISOPROTURON|CHLORTOLURON|TERBUTHYLAZ|DIM[ÉE]THACHLOR|PROPYZAMIDE|BOSCALID|T[ÉE]BUCONAZOLE|IMIDACLOPRIDE|\bESA\b|\bOXA\b|D[ÉE]S[ÉE]THYL|D[ÉE]SISOPROPYL|D[ÉE]SPH[ÉE]NYL|CHLORIDAZONE|M[ÉE]TALD[ÉE]HYDE|M[ÉE]COPROP|2,4-D|MCPA|OXADIXYL|FLUFENACET|NICOSULFURON|DIMETHENAMID|CHLORM[ÉE]QUAT/i,
    },
    {
      key: 'metals',
      labelKey: 'category_metals',
      match: /^PLOMB|NICKEL|CUIVRE|ARSENIC|CADMIUM|CHROME|ANTIMOINE|S[ÉE]L[ÉE]NIUM|MERCURE|URANIUM|ALUMINIUM/i,
    },
    {
      key: 'disinfection',
      labelKey: 'category_disinfection',
      match: /TRIHALOM|CHLOROFORME|BROMOFORME|DICHLOROBROMO|DIBROMOCHLORO|BROMATES|CHLORITES|CHLORATES/i,
    },
    {
      key: 'other',
      labelKey: 'category_other',
      match:
        /NITRATES|NITRITES|CHLORURE DE VINYLE|BENZ[ÈE]NE|T[ÉE]TRACHLORO|TRICHLORO|TOLU[ÈE]NE|HAP\b|BENZO|FLUORANTH|MICROCYSTINE|PERCHLORATE|1,4-DIOXANE/i,
    },
  ];

  const BENIGN_PARAMETER =
    /\bPH\b|TEMP[ÉE]RATURE|CONDUCTIV|TURBIDIT|TITRE|DURET|CALCIUM|MAGN[ÉE]SIUM|SODIUM|POTASSIUM|HYDROG[ÉE]NOCARBONATES|BICARBONAT|\bTAC\b|SILICE|SILICATES|OXYG[ÈE]NE|CARBONE ORGANIQUE|CHLORE|SULFATES|CHLORURES\b|FLUORURES|FER\b|FER TOTAL|MANGAN[ÈE]SE|AMMONIUM|ODEUR|SAVEUR|COULEUR|ASPECT|BACT[ÉE]RIES|COLIFORM|ESCHERICHIA|ENT[ÉE]ROCOQ|GERMES|SPORES|MICRO-?ORGANISMES|[ÉE]QUILIBRE|LANGELIER|DEMANDE EN CHLORE/i;

  class WaterReport extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.config = this.parseConfig();
      this.labels = {
        ...DEFAULT_LABELS,
        ...this.parseLabelSettings(this.config.copy?.labelsRaw),
      };
      this.requestController = null;
      this.current = {
        postcode: '',
        commune: null,
        network: null,
      };
      this.report = null;
      this.unlocked = false;
      this.lastSubmissionSignature = '';
      this.activeDetailsCategory = '';

      this.cacheElements();
      this.bindHandlers();
      this.applyCopy();
      this.normalizeStaticSentenceCase();
      this.addEventListeners();
      this.resetInterface({ preservePostcode: true });
      this.handleDeepLink();
    }

    disconnectedCallback() {
      this.abortActiveRequest();
      this.removeEventListeners();
    }

    cacheElements() {
      this.searchPanel = this.querySelector('[data-search-panel]');
      this.searchForm = this.querySelector('[data-search-form]');
      this.postcodeInput = this.querySelector('[data-postcode]');
      this.searchButton = this.querySelector('[data-search-button]');
      this.exampleButtons = Array.from(this.querySelectorAll('[data-example-postcode]'));
      this.progress = this.querySelector('[data-progress]');
      this.progressText = this.querySelector('[data-progress-text]');
      this.progressSteps = Array.from(this.querySelectorAll('[data-progress-step]'));
      this.communePicker = this.querySelector('[data-commune-picker]');
      this.communeOptions = this.querySelector('[data-commune-options]');
      this.networkPicker = this.querySelector('[data-network-picker]');
      this.networkOptions = this.querySelector('[data-network-options]');
      this.errorBox = this.querySelector('[data-error]');
      this.emailGate = this.querySelector('[data-email-gate]');
      this.gateContext = this.querySelector('[data-gate-context]');
      this.emailForm = this.querySelector('[data-email-form]');
      this.emailInput = this.querySelector('[data-email]');
      this.consentInput = this.querySelector('[data-consent]');
      this.emailSubmit = this.querySelector('[data-email-submit]');
      this.previewBypass = this.querySelector('[data-preview-bypass]');
      this.gateError = this.querySelector('[data-gate-error]');
      this.gateSuccess = this.querySelector('[data-gate-success]');
      this.results = this.querySelector('[data-results]');
      this.summary = this.querySelector('.water-report__summary');
      this.locationCityOutput = this.querySelector('[data-location-city]');
      this.locationOutput = this.querySelector('[data-location]');
      this.verdictOutput = this.querySelector('[data-verdict]');
      this.summaryCopy = this.querySelector('[data-summary-copy]');
      this.coverageCard = this.querySelector('[data-coverage-card]');
      this.coverageRing = this.querySelector('[data-coverage-ring]');
      this.coverageValue = this.querySelector('[data-coverage-value]');
      this.coverageDetail = this.querySelector('[data-coverage-detail]');
      this.detectedCount = this.querySelector('[data-detected-count]');
      this.overviewExceeded = this.querySelector('[data-overview-exceeded]');
      this.overviewWithin = this.querySelector('[data-overview-within]');
      this.overviewExceededBand = this.querySelector('[data-overview-exceeded-band]');
      this.overviewWithinBand = this.querySelector('[data-overview-within-band]');
      this.overviewQuantifiedBand = this.querySelector('[data-overview-quantified-band]');
      this.contrastDetected = this.querySelector('[data-contrast-detected]');
      this.contrastDetectedLabel = this.querySelector('[data-contrast-detected-label]');
      this.contrastDetectedSuffix = this.querySelector('[data-contrast-detected-suffix]');
      this.contrastParameterCount = this.querySelector('[data-contrast-parameter-count]');
      this.contrastExceeded = this.querySelector('[data-contrast-exceeded]');
      this.latestDate = this.querySelector('[data-latest-date]');
      this.sampleCount = this.querySelector('[data-sample-count]');
      this.parameterCount = this.querySelector('[data-parameter-count]');
      this.parameterGrid = this.querySelector('[data-parameter-grid]');
      this.detailsTabs = this.querySelector('[data-details-tabs]');
      this.detailsPanel = this.querySelector('[data-details-panel]');
      this.recommendations = this.querySelector('[data-recommendations]');
      this.recommendationsHeading = this.querySelector('[data-recommendations-heading]');
      this.recommendationList = this.querySelector('[data-recommendation-list]');
      this.resetButton = this.querySelector('[data-reset]');
      this.liveRegion = this.querySelector('[data-live-region]');
    }

    bindHandlers() {
      this.onSearchSubmit = this.handleSearchSubmit.bind(this);
      this.onExampleClick = this.handleExampleClick.bind(this);
      this.onEmailSubmit = this.handleEmailSubmit.bind(this);
      this.onPreviewBypass = this.handlePreviewBypass.bind(this);
      this.onDetailsTabClick = this.handleDetailsTabClick.bind(this);
      this.onDetailsTabKeydown = this.handleDetailsTabKeydown.bind(this);
      this.onResetClick = this.handleResetClick.bind(this);
    }

    addEventListeners() {
      this.searchForm?.addEventListener('submit', this.onSearchSubmit);
      this.exampleButtons.forEach((button) => button.addEventListener('click', this.onExampleClick));
      this.emailForm?.addEventListener('submit', this.onEmailSubmit);
      this.previewBypass?.addEventListener('click', this.onPreviewBypass);
      this.detailsTabs?.addEventListener('click', this.onDetailsTabClick);
      this.detailsTabs?.addEventListener('keydown', this.onDetailsTabKeydown);
      this.resetButton?.addEventListener('click', this.onResetClick);
    }

    removeEventListeners() {
      this.searchForm?.removeEventListener('submit', this.onSearchSubmit);
      this.exampleButtons?.forEach((button) => button.removeEventListener('click', this.onExampleClick));
      this.emailForm?.removeEventListener('submit', this.onEmailSubmit);
      this.previewBypass?.removeEventListener('click', this.onPreviewBypass);
      this.detailsTabs?.removeEventListener('click', this.onDetailsTabClick);
      this.detailsTabs?.removeEventListener('keydown', this.onDetailsTabKeydown);
      this.resetButton?.removeEventListener('click', this.onResetClick);
    }

    parseConfig() {
      const configElement = this.querySelector('[data-water-report-config]');
      if (!configElement) return {};

      try {
        return JSON.parse(configElement.textContent);
      } catch (error) {
        console.warn('Water report configuration could not be parsed.', error);
        return {};
      }
    }

    parseLabelSettings(rawValue) {
      if (typeof rawValue !== 'string') return {};

      const labels = rawValue.split(/\r?\n/).reduce((result, row) => {
        const separatorIndex = row.indexOf('=');
        if (separatorIndex < 1) return result;

        const key = row.slice(0, separatorIndex).trim();
        const value = row.slice(separatorIndex + 1).trim();

        if (key && value) result[key] = value;
        return result;
      }, {});

      const legacyLabels = {
        coverage_detail_label: 'paramètres comparables respectent leur limite API',
        coverage_na_detail: 'Aucune limite API comparable sur la période',
        overview_exceeded: 'au-dessus des limites API',
        overview_within: 'dans les limites API',
        overview_quantified: 'substances quantifiées',
      };

      Object.entries(legacyLabels).forEach(([key, legacyValue]) => {
        if (labels[key] === legacyValue) labels[key] = DEFAULT_LABELS[key];
      });

      return labels;
    }

    applyCopy() {
      this.querySelectorAll('[data-label]').forEach((element) => {
        const key = element.dataset.label;
        if (key && this.labels[key]) element.textContent = this.labels[key];
      });

      if (this.postcodeInput) this.postcodeInput.placeholder = this.labels.postcode_placeholder;
      if (this.emailInput) this.emailInput.placeholder = this.labels.email_placeholder;
      if (this.searchButton) this.searchButton.textContent = this.labels.search_button;
      if (this.emailSubmit) this.emailSubmit.textContent = this.labels.gate_button;
      if (this.previewBypass) this.previewBypass.textContent = this.labels.preview_bypass;
      if (this.detailsTabs) this.detailsTabs.setAttribute('aria-label', this.labels.details_tabs_label);
      if (this.resetButton) this.resetButton.textContent = this.labels.reset;
    }

    normalizeStaticSentenceCase() {
      this.querySelectorAll('[data-sentence-case]').forEach((container) => {
        const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
        const textNodes = [];
        let hasStarted = false;

        while (walker.nextNode()) textNodes.push(walker.currentNode);

        textNodes.forEach((node) => {
          const value = String(node.nodeValue || '');
          if (!/\p{L}/u.test(value)) return;

          const normalized = value
            .toLocaleLowerCase('fr-FR')
            .replace(/\bpfas\b/giu, 'PFAS')
            .replace(/\bpfoa\b/giu, 'PFOA')
            .replace(/\bpfos\b/giu, 'PFOS');

          node.nodeValue = hasStarted
            ? normalized
            : normalized.replace(/\p{L}/u, (letter) => letter.toLocaleUpperCase('fr-FR'));
          hasStarted = true;
        });
      });
    }

    handleDeepLink() {
      if (window.__euroguardWaterReportDeepLinkHandled) return;

      const postcode = new URLSearchParams(window.location.search).get('cp');
      if (!postcode || !/^\d{5}$/.test(postcode)) return;

      window.__euroguardWaterReportDeepLinkHandled = true;
      if (this.postcodeInput) this.postcodeInput.value = postcode;

      window.requestAnimationFrame(() => {
        this.startSearch(postcode);
      });
    }

    handleSearchSubmit(event) {
      event.preventDefault();
      this.startSearch(this.postcodeInput?.value || '');
    }

    handleExampleClick(event) {
      const button = event.currentTarget;
      if (!(button instanceof HTMLButtonElement)) return;

      const postcode = button.dataset.examplePostcode || '';
      if (this.postcodeInput) this.postcodeInput.value = postcode;
      this.startSearch(postcode);
    }

    async startSearch(rawPostcode) {
      const postcode = String(rawPostcode).trim();
      this.resetInterface({ preservePostcode: true });

      if (!/^\d{5}$/.test(postcode)) {
        this.showError(this.labels.postcode_error, 'invalid_postcode');
        this.postcodeInput?.focus();
        return;
      }

      this.current.postcode = postcode;
      this.requestController = new AbortController();
      this.setSearchBusy(true);
      this.setProgress('commune', this.labels.loading_communes);

      try {
        const url = new URL(API_GEO);
        url.searchParams.set('codePostal', postcode);
        url.searchParams.set('fields', 'nom,code,population');
        url.searchParams.set('format', 'json');

        const communes = await this.fetchJson(url.toString(), this.requestController.signal);
        if (!Array.isArray(communes) || communes.length === 0) {
          this.showError(this.labels.no_commune_error, 'no_commune');
          return;
        }

        this.communes = communes.sort((a, b) => Number(b.population || 0) - Number(a.population || 0));

        if (this.communes.length === 1) {
          await this.selectCommune(this.communes[0]);
          return;
        }

        this.renderCommunePicker();
        this.hideProgress();
        this.setSearchBusy(false);
      } catch (error) {
        if (this.isAbortError(error)) return;
        this.showError(this.labels.geo_error, 'geo_api');
      }
    }

    renderCommunePicker() {
      if (!this.communeOptions || !this.communePicker) return;

      this.communeOptions.replaceChildren();

      this.communes.forEach((commune) => {
        const button = document.createElement('button');
        const name = document.createElement('strong');
        const population = document.createElement('span');

        button.type = 'button';
        button.className = 'water-report__picker-option';
        name.textContent = commune.nom || commune.code || '';
        population.textContent = commune.population
          ? `${this.formatNumber(commune.population, 0)} ${this.labels.inhabitants_label}`
          : commune.code || '';

        button.append(name, population);
        button.addEventListener(
          'click',
          () => {
            this.selectCommune(commune);
          },
          { once: true }
        );
        this.communeOptions.append(button);
      });

      this.communePicker.hidden = false;
      this.communeOptions.querySelector('button')?.focus();
    }

    async selectCommune(commune) {
      if (!commune?.code) return;

      this.current.commune = commune;
      if (this.communePicker) this.communePicker.hidden = true;
      if (this.networkPicker) this.networkPicker.hidden = true;
      this.hideError();
      this.setSearchBusy(true);
      this.setProgress('network', this.labels.loading_networks);

      try {
        const currentYear = new Date().getFullYear();
        let networkRows = [];

        for (const year of [currentYear, currentYear - 1]) {
          const url = new URL(API_NETWORKS);
          url.searchParams.set('code_commune', commune.code);
          url.searchParams.set('annee', String(year));
          url.searchParams.set('size', '100');

          const response = await this.fetchJson(url.toString(), this.requestController.signal);
          networkRows = Array.isArray(response?.data) ? response.data : [];
          if (networkRows.length > 0) break;
        }

        const seenNetworks = new Set();
        this.networks = networkRows.filter((network) => {
          if (!network?.code_reseau || seenNetworks.has(network.code_reseau)) return false;
          seenNetworks.add(network.code_reseau);
          return true;
        });

        if (this.networks.length === 0) {
          await this.loadResults(null);
          return;
        }

        if (this.networks.length === 1) {
          await this.loadResults(this.networks[0]);
          return;
        }

        this.renderNetworkPicker();
        this.hideProgress();
        this.setSearchBusy(false);
      } catch (error) {
        if (this.isAbortError(error)) return;
        this.showError(this.labels.network_error, 'network_api');
      }
    }

    renderNetworkPicker() {
      if (!this.networkOptions || !this.networkPicker) return;

      this.networkOptions.replaceChildren();

      this.networks.forEach((network) => {
        const button = document.createElement('button');
        const name = document.createElement('strong');
        const area = document.createElement('span');

        button.type = 'button';
        button.className = 'water-report__picker-option';
        name.textContent = this.titleCase(
          network.nom_reseau || `${this.labels.network_fallback_label} ${network.code_reseau}`
        );
        area.textContent = network.nom_quartier || network.code_reseau;

        button.append(name, area);
        button.addEventListener(
          'click',
          () => {
            this.loadResults(network);
          },
          { once: true }
        );
        this.networkOptions.append(button);
      });

      this.networkPicker.hidden = false;
      this.networkOptions.querySelector('button')?.focus();
    }

    async loadResults(network) {
      this.current.network = network;
      if (this.networkPicker) this.networkPicker.hidden = true;
      this.hideError();
      this.setSearchBusy(true);
      this.setProgress('results', this.labels.loading_results);

      const minimumDate = new Date();
      minimumDate.setMonth(minimumDate.getMonth() - this.getDataWindowMonths());

      const url = new URL(API_RESULTS);
      if (network?.code_reseau) {
        url.searchParams.set('code_reseau', network.code_reseau);
      } else {
        url.searchParams.set('code_commune', this.current.commune.code);
      }
      url.searchParams.set('date_min_prelevement', `${minimumDate.toISOString().slice(0, 10)} 00:00:00`);
      url.searchParams.set('fields', RESULT_FIELDS);
      url.searchParams.set('size', String(PAGE_SIZE));
      url.searchParams.set('sort', 'desc');

      try {
        const rows = await this.fetchAllResultPages(url.toString(), this.requestController.signal);
        if (rows.length === 0) {
          this.showError(this.labels.no_data_error, 'no_results');
          return;
        }

        this.report = this.analyseRows(rows);
        this.hideProgress();
        this.setSearchBusy(false);
        this.showEmailGate();
      } catch (error) {
        if (this.isAbortError(error)) return;
        this.showError(this.labels.water_api_error, 'water_api');
      }
    }

    async fetchAllResultPages(initialUrl, signal) {
      const rows = [];
      let nextUrl = initialUrl;
      let page = 0;

      while (nextUrl && rows.length < MAX_RESULT_ROWS && page < 10) {
        const response = await this.fetchJson(nextUrl.replace(/^http:/, 'https:'), signal);
        const pageRows = Array.isArray(response?.data) ? response.data : [];
        const remaining = MAX_RESULT_ROWS - rows.length;

        rows.push(...pageRows.slice(0, remaining));
        nextUrl = response?.next || null;
        page += 1;

        if (nextUrl) this.setProgress('results', this.labels.loading_results);
      }

      return rows;
    }

    analyseRows(inputRows) {
      const rows = [...inputRows].sort(
        (a, b) => this.timestamp(b.date_prelevement) - this.timestamp(a.date_prelevement)
      );
      const latestRow = rows[0] || {};
      const latestSampleCode = latestRow.code_prelevement || '';
      const latestSampleRows = latestSampleCode
        ? rows.filter((row) => row.code_prelevement === latestSampleCode)
        : [latestRow];
      const conformity = {
        bacteriological: this.resolveConformity(
          latestSampleRows.map((row) => row.conformite_limites_bact_prelevement)
        ),
        physicochemical: this.resolveConformity(
          latestSampleRows.map((row) => row.conformite_limites_pc_prelevement)
        ),
      };
      const latestByParameter = new Map();

      rows.forEach((row) => {
        const key = this.getParameterKey(row);
        if (key && !latestByParameter.has(key)) latestByParameter.set(key, row);
      });

      const latestParameters = Array.from(latestByParameter.values());
      const regulatoryCoverage = this.calculateRegulatoryCoverage(latestParameters);
      const parameterCards = (this.config.parameters || []).map((setting) =>
        this.buildParameterCard(setting, latestParameters)
      );
      const detected = this.buildDetectedSubstances(latestParameters);
      const concerns = this.evaluateConcerns({
        latestParameters,
        parameterCards,
        detected,
        conformity,
      });
      const sampleCodes = new Set(rows.map((row) => row.code_prelevement).filter(Boolean));
      const networkName =
        this.current.network?.nom_reseau ||
        latestRow.reseaux?.[0]?.nom ||
        latestSampleRows.find((row) => row.reseaux?.[0]?.nom)?.reseaux?.[0]?.nom ||
        '';

      return {
        rows,
        latestDate: latestRow.date_prelevement || '',
        latestSampleCode,
        conformity,
        isConforming: conformity.bacteriological !== 'N' && conformity.physicochemical !== 'N',
        sampleCount: sampleCodes.size,
        parameterCount: latestByParameter.size,
        comparableCount: regulatoryCoverage.comparableCount,
        compliantCount: regulatoryCoverage.compliantCount,
        exceededCount: regulatoryCoverage.exceededCount,
        coveragePercentage: regulatoryCoverage.percentage,
        parameterCards,
        detected,
        concerns,
        networkName,
        distributor: latestRow.nom_distributeur || '',
      };
    }

    calculateRegulatoryCoverage(latestParameters) {
      const comparable = latestParameters
        .map((row) => ({
          value: this.toNumber(row.resultat_numerique),
          limit: this.parseLimit(row.limite_qualite_parametre),
        }))
        .filter(({ value, limit }) => value != null && limit != null);
      const compliantCount = comparable.filter(({ value, limit }) => value <= limit).length;
      const comparableCount = comparable.length;

      return {
        comparableCount,
        compliantCount,
        exceededCount: comparableCount - compliantCount,
        percentage: comparableCount > 0 ? Math.round((compliantCount / comparableCount) * 100) : null,
      };
    }

    buildParameterCard(setting, latestParameters) {
      const definition = PARAMETER_DEFINITIONS[setting.key];
      if (!definition) return null;

      const row = latestParameters.find((item) => definition.match.test(item.libelle_parametre_maj || ''));
      const title = String(setting.title || '').trim() || definition.title;
      const description = String(setting.description || '').trim() || definition.description;

      if (!row) {
        return {
          key: setting.key,
          title,
          description,
          missing: true,
          unit: definition.unit,
          scaleMax: definition.scaleMax,
          limit: definition.fallbackLimit ?? null,
        };
      }

      const numericValue = this.toNumber(row.resultat_numerique);
      const alphaValue = String(row.resultat_alphanumerique || '').trim();
      const belowQuantification = /^</.test(alphaValue);
      const value = numericValue ?? 0;
      const apiLimit = this.parseLimit(row.limite_qualite_parametre);
      const limit = apiLimit ?? definition.fallbackLimit ?? null;
      const scaleMax = Math.max(definition.scaleMax || 0, limit || 0, value || 0, 1);

      return {
        key: setting.key,
        title,
        description,
        missing: false,
        value,
        alphaValue,
        belowQuantification,
        unit: row.libelle_unite || definition.unit,
        limit,
        scaleMax,
        date: row.date_prelevement || '',
        overLimit: limit != null && value > limit,
      };
    }

    buildDetectedSubstances(latestParameters) {
      return latestParameters
        .filter((row) => {
          const label = row.libelle_parametre_maj || '';
          const value = this.toNumber(row.resultat_numerique);
          const alpha = String(row.resultat_alphanumerique || '').trim();

          if (!label || BENIGN_PARAMETER.test(label)) return false;
          if (row.code_type_parametre === 'O') return false;
          if (!(value > 0) || /^</.test(alpha)) return false;

          return CATEGORY_DEFINITIONS.some((category) => category.match.test(label)) || Boolean(row.limite_qualite_parametre);
        })
        .map((row) => {
          const label = row.libelle_parametre_maj || '';
          const category = CATEGORY_DEFINITIONS.find((item) => item.match.test(label));
          const value = this.toNumber(row.resultat_numerique) || 0;
          const limit = this.parseLimit(row.limite_qualite_parametre);

          return {
            key: this.getParameterKey(row),
            name: row.libelle_parametre_web || row.libelle_parametre || this.titleCase(label),
            value,
            unit: row.libelle_unite || '',
            category: category?.key || 'other',
            overLimit: limit != null && value > limit,
          };
        })
        .sort((a, b) => {
          if (a.category !== b.category) return a.category.localeCompare(b.category, 'fr');
          return a.name.localeCompare(b.name, 'fr');
        });
    }

    evaluateConcerns({ latestParameters, parameterCards, detected, conformity }) {
      const categories = new Set(detected.map((item) => item.category));
      const parameterMap = new Map(
        parameterCards.filter(Boolean).map((card) => [card.key, card])
      );
      const fluorideRow = latestParameters.find((row) => /^FLUORURES/i.test(row.libelle_parametre_maj || ''));
      const fluorideValue = this.toNumber(fluorideRow?.resultat_numerique) || 0;
      const concerns = [];
      const addConcern = (key, labelKey, value = '') => {
        concerns.push({
          key,
          label: this.labels[labelKey],
          value,
        });
      };

      const chlorine = parameterMap.get('chlorine');
      if (chlorine && !chlorine.missing && chlorine.value > 0) {
        addConcern('chlorine', 'concern_chlorine', this.formatMeasurement(chlorine.value, chlorine.unit));
      }

      const pfas = parameterMap.get('pfas');
      if ((pfas && !pfas.missing && pfas.value > 0) || categories.has('pfas')) {
        addConcern(
          'pfas',
          'concern_pfas',
          pfas && !pfas.missing && pfas.value > 0 ? this.formatMeasurement(pfas.value, pfas.unit) : ''
        );
      }

      if (fluorideValue >= 0.5) {
        addConcern('fluoride', 'concern_fluoride', this.formatMeasurement(fluorideValue, fluorideRow?.libelle_unite || 'mg/L'));
      }

      if (conformity.bacteriological === 'N') {
        addConcern('bacteriological', 'concern_bacteriological');
      }

      if (categories.has('pesticides')) addConcern('pesticides', 'concern_pesticides');
      if (categories.has('metals')) addConcern('metals', 'concern_metals');
      if (categories.has('disinfection')) addConcern('disinfection', 'concern_disinfection');

      return concerns;
    }

    showEmailGate() {
      if (!this.emailGate || !this.report) return;

      const communeName = this.current.commune?.nom || '';
      const networkName = this.titleCase(this.report.networkName || '');
      this.gateContext.textContent = networkName
        ? `${communeName} · ${networkName}`
        : communeName;
      this.emailGate.hidden = false;
      this.results.hidden = true;
      this.hideGateMessages();
      this.emailGate.scrollIntoView({ behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });

      window.requestAnimationFrame(() => {
        this.emailInput?.focus({ preventScroll: true });
      });
    }

    async handleEmailSubmit(event) {
      event.preventDefault();
      if (!this.report) return;

      const email = String(this.emailInput?.value || '').trim().toLowerCase();
      this.hideGateMessages();

      if (!email || !this.emailInput?.checkValidity()) {
        this.showGateError(this.labels.email_error);
        this.emailInput?.focus();
        return;
      }

      if (!this.consentInput?.checked) {
        this.showGateError(this.labels.consent_error);
        this.consentInput?.focus();
        return;
      }

      const publicApiKey = String(this.config.klaviyo?.publicApiKey || '').trim();
      const listId = String(this.config.klaviyo?.listId || '').trim();

      if (!publicApiKey) {
        this.showGateError(this.labels.config_error);
        return;
      }

      const properties = this.buildKlaviyoProperties();
      const signature = JSON.stringify({
        email,
        listId,
        postcode: this.current.postcode,
        commune: this.current.commune?.code || '',
        network: this.current.network?.code_reseau || this.report?.networkName || '',
        latestDate: this.report?.latestDate || '',
      });

      if (signature === this.lastSubmissionSignature) {
        this.unlockReport();
        return;
      }

      this.setGateBusy(true);

      try {
        const requests = [
          this.createKlaviyoProfile(email, properties),
          this.createKlaviyoEvent(email, properties),
        ];

        if (listId) {
          requests.push(this.createKlaviyoSubscription(email));
        }

        const results = await Promise.allSettled(requests);
        const failedRequests = results.filter((result) => result.status === 'rejected');
        const successfulRequests = results.filter((result) => result.status === 'fulfilled');

        if (failedRequests.length > 0) {
          console.warn('Water report Klaviyo submission partially failed.', failedRequests);
        }

        if (successfulRequests.length === 0) {
          throw failedRequests[0]?.reason || new Error('Klaviyo submission failed');
        }

        this.lastSubmissionSignature = signature;
        this.showGateSuccess(this.labels.gate_success);
        this.track('rapport_eau_email', this.getAnalyticsPayload());
        this.unlockReport();
      } catch (error) {
        console.warn('Water report Klaviyo submission failed.', error);
        this.showGateError(this.labels.gate_error);
        this.track('rapport_eau_error', {
          stage: 'klaviyo',
          code: 'klaviyo_submit',
          postcode: this.current.postcode,
        });
      } finally {
        this.setGateBusy(false);
      }
    }

    handlePreviewBypass() {
      if (!this.config.designMode || !this.config.previewBypassEnabled || !this.report) return;
      this.unlockReport();
    }

    async createKlaviyoProfile(email, properties) {
      const publicApiKey = String(this.config.klaviyo.publicApiKey).trim();
      const url = new URL('https://a.klaviyo.com/client/profiles/');
      url.searchParams.set('company_id', publicApiKey);

      const response = await this.fetchWithTimeout(url.toString(), {
        method: 'POST',
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
          revision: this.config.klaviyo.revision || '2026-04-15',
        },
        body: JSON.stringify({
          data: {
            type: 'profile',
            attributes: {
              email,
              properties,
            },
          },
        }),
      });

      if (!response.ok) {
        throw new Error(await this.getKlaviyoErrorMessage(response, 'profile'));
      }

      return response;
    }

    async createKlaviyoSubscription(email) {
      const publicApiKey = String(this.config.klaviyo.publicApiKey).trim();
      const listId = String(this.config.klaviyo.listId).trim();

      if (!listId) {
        throw new Error('Klaviyo list ID is required for a marketing subscription');
      }

      const url = new URL('https://a.klaviyo.com/client/subscriptions');
      url.searchParams.set('company_id', publicApiKey);

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                  },
                },
              },
            },
            custom_source: this.config.klaviyo.source || 'Water Report',
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId,
              },
            },
          },
        },
      };

      const response = await this.fetchWithTimeout(url.toString(), {
        method: 'POST',
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
          revision: this.config.klaviyo.revision || '2026-04-15',
        },
        body: JSON.stringify(payload),
      });

      if (response.status !== 202) {
        throw new Error(await this.getKlaviyoErrorMessage(response, 'subscription'));
      }

      return response;
    }

    async getKlaviyoErrorMessage(response, requestType) {
      let detail = '';

      try {
        const payload = await response.clone().json();
        detail = payload?.errors
          ?.map((error) => error?.detail || error?.title)
          .filter(Boolean)
          .join('; ');
      } catch (_error) {
        // Klaviyo normally returns JSON:API errors, but keep a stable fallback.
      }

      return `Klaviyo ${requestType} returned ${response.status}${detail ? `: ${detail}` : ''}`;
    }

    async createKlaviyoEvent(email, properties) {
      const publicApiKey = String(this.config.klaviyo.publicApiKey).trim();
      const url = new URL('https://a.klaviyo.com/client/events');
      url.searchParams.set('company_id', publicApiKey);

      const response = await this.fetchWithTimeout(url.toString(), {
        method: 'POST',
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
          revision: this.config.klaviyo.revision || '2026-04-15',
        },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties,
              metric: {
                data: {
                  type: 'metric',
                  attributes: {
                    name: this.config.klaviyo.eventName || 'water_report_complete',
                  },
                },
              },
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                  },
                },
              },
            },
          },
        }),
      });

      if (!response.ok) {
        throw new Error(await this.getKlaviyoErrorMessage(response, 'event'));
      }

      return response;
    }

    buildKlaviyoProperties() {
      const completedAt = new Date().toISOString();

      return {
        water_report_completed_at: completedAt,
        water_report_marketing_consent: true,
        water_report_marketing_consent_at: completedAt,
        water_report_source: this.config.klaviyo?.source || 'Water Report',
        entered_postcode: this.current.postcode,
        detected_city: this.current.commune?.nom || null,
        commune_code: this.current.commune?.code || null,
        water_network: this.report?.networkName || null,
        water_network_code: this.current.network?.code_reseau || null,
        water_conformity: this.report?.isConforming ? 'conforming' : 'nonconforming',
        latest_sample_date: this.report?.latestDate || null,
        detected_count: this.report?.detected.length || 0,
        detected_concerns: (this.report?.concerns || []).map((concern) => concern.key),
        sample_count: this.report?.sampleCount || 0,
        parameter_count: this.report?.parameterCount || 0,
        data_window_months: this.getDataWindowMonths(),
      };
    }

    unlockReport() {
      if (!this.report) return;

      this.unlocked = true;
      this.renderReport();
      if (this.emailGate) this.emailGate.hidden = true;
      if (this.results) this.results.hidden = false;
      this.results?.scrollIntoView({ behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });

      window.requestAnimationFrame(() => {
        if (this.verdictOutput) {
          this.verdictOutput.tabIndex = -1;
          this.verdictOutput.focus({ preventScroll: true });
        }
      });
    }

    renderReport() {
      this.renderSummary();
      this.renderParameters();
      this.renderDetectedDetails();
      this.renderRecommendations();
      this.track('rapport_eau_viewed', this.getAnalyticsPayload());
    }

    renderSummary() {
      const report = this.report;
      if (!report) return;

      const communeName = this.current.commune?.nom || '';
      const networkName = this.titleCase(report.networkName || '');
      const locationParts = [
        this.current.postcode && `Code postal ${this.current.postcode}`,
        networkName && `${this.labels.network_fallback_label} ${networkName}`,
      ].filter(Boolean);

      if (this.locationCityOutput) this.locationCityOutput.textContent = this.titleCase(communeName);
      if (this.locationOutput) this.locationOutput.textContent = locationParts.join(' · ');
      if (this.verdictOutput) {
        this.verdictOutput.textContent = this.sentenceCase(
          report.isConforming ? this.config.copy?.conforming : this.config.copy?.nonconforming
        );
      }
      if (this.summaryCopy) {
        this.summaryCopy.textContent = report.isConforming
          ? this.config.copy?.summaryConforming
          : this.config.copy?.summaryNonconforming;
      }
      this.summary?.classList.toggle('is-nonconforming', !report.isConforming);
      this.renderRegulatoryCoverage(report);

      const detectedLength = report.detected.length;
      const hasDetectedSubstances = detectedLength > 0;
      if (this.detectedCount) this.detectedCount.textContent = this.formatNumber(detectedLength, 0);
      if (this.contrastDetected) this.contrastDetected.textContent = this.formatNumber(detectedLength, 0);
      if (this.contrastDetectedLabel) {
        this.contrastDetectedLabel.textContent =
          detectedLength === 1 ? this.labels.detected_singular : this.labels.detected_plural;
      }
      if (this.contrastDetectedSuffix) {
        this.contrastDetectedSuffix.textContent = hasDetectedSubstances
          ? this.labels.contrast_limits_but_suffix
          : this.labels.contrast_limits_but_suffix_zero;
      }
      if (this.contrastParameterCount) {
        this.contrastParameterCount.textContent = this.formatNumber(report.parameterCount, 0);
      }
      const hasComparableLimits = report.comparableCount > 0;
      if (this.overviewExceeded) {
        this.overviewExceeded.textContent = hasComparableLimits
          ? this.formatNumber(report.exceededCount, 0)
          : this.labels.coverage_na;
      }
      if (this.overviewWithin) {
        this.overviewWithin.textContent = hasComparableLimits
          ? this.formatNumber(report.compliantCount, 0)
          : this.labels.coverage_na;
      }
      this.overviewExceededBand?.classList.toggle('is-na', !hasComparableLimits);
      this.overviewWithinBand?.classList.toggle('is-na', !hasComparableLimits);
      this.overviewExceededBand?.classList.toggle(
        'is-zero',
        hasComparableLimits && report.exceededCount === 0
      );
      this.overviewExceededBand?.classList.toggle(
        'has-exceedance',
        hasComparableLimits && report.exceededCount > 0
      );
      this.overviewQuantifiedBand?.classList.toggle('has-detections', hasDetectedSubstances);
      this.overviewQuantifiedBand?.classList.toggle('is-zero', !hasDetectedSubstances);
      if (this.contrastExceeded) {
        this.contrastExceeded.textContent = hasComparableLimits
          ? this.formatNumber(report.exceededCount, 0)
          : this.labels.coverage_na;
      }
      if (this.latestDate) this.latestDate.textContent = this.formatDate(report.latestDate);
      if (this.sampleCount) this.sampleCount.textContent = this.formatNumber(report.sampleCount, 0);
      if (this.parameterCount) this.parameterCount.textContent = this.formatNumber(report.parameterCount, 0);
    }

    renderRegulatoryCoverage(report) {
      const percentage = report.coveragePercentage;
      const hasCoverage = Number.isFinite(percentage);
      const coverageClass = !hasCoverage
        ? 'is-na'
        : report.exceededCount > 0
          ? 'is-exceeded'
          : percentage === 100
            ? 'is-complete'
            : 'is-partial';

      this.coverageCard?.classList.remove('is-na', 'is-exceeded', 'is-complete', 'is-partial');
      this.coverageCard?.classList.add(coverageClass);
      if (this.coverageRing) {
        this.coverageRing.style.setProperty('--coverage', hasCoverage ? String(percentage) : '0');
        const progressCircle = this.coverageRing.querySelector('.water-report__coverage-progress');
        if (progressCircle) {
          progressCircle.style.strokeDashoffset = String(hasCoverage ? 100 - percentage : 100);
        }
      }
      if (this.coverageValue) {
        this.coverageValue.textContent = hasCoverage ? `${percentage}%` : this.labels.coverage_na;
      }
      if (this.coverageDetail) {
        this.coverageDetail.textContent = hasCoverage
          ? `${this.formatNumber(report.compliantCount, 0)} sur ${this.formatNumber(
              report.comparableCount,
              0
            )} ${this.labels.coverage_detail_label}`
          : this.labels.coverage_na_detail;
      }
    }

    renderParameters() {
      if (!this.parameterGrid) return;

      const cards = (this.report?.parameterCards || []).filter(Boolean);
      this.parameterGrid.innerHTML = cards.map((card) => this.getParameterCardMarkup(card)).join('');
    }

    getParameterCardMarkup(card) {
      if (card.missing) {
        return `
          <article class="water-report__parameter-card">
            <div class="water-report__parameter-head">
              <div>
                <h3 class="water-report__parameter-name">${this.escapeHtml(this.parameterTitle(card.title, card.key))}</h3>
                <span class="water-report__parameter-status">${this.escapeHtml(this.labels.not_measured_label)}</span>
              </div>
            </div>
            <p class="water-report__parameter-description">${this.escapeHtml(card.description)}</p>
          </article>
        `;
      }

      const position = Math.max(0, Math.min(100, (card.value / card.scaleMax) * 100));
      const statusClass = card.overLimit ? ' water-report__parameter-status--over' : '';
      const status = card.overLimit ? this.labels.limit_exceeded_label : this.labels.measured_label;
      const displayedValue = card.belowQuantification
        ? this.escapeHtml(card.alphaValue || '< seuil')
        : this.formatNumber(card.value);
      const limitLabel =
        card.limit != null
          ? `${this.labels.legal_limit_label} : ${this.formatMeasurement(card.limit, card.unit)}`
          : `${this.formatNumber(card.scaleMax)} ${card.unit}`;

      return `
        <article class="water-report__parameter-card">
          <div class="water-report__parameter-head">
            <div>
              <h3 class="water-report__parameter-name">${this.escapeHtml(this.parameterTitle(card.title, card.key))}</h3>
              <span class="water-report__parameter-status${statusClass}">${this.escapeHtml(status)}</span>
            </div>
            <div class="water-report__parameter-value">
              ${displayedValue}<small>${this.escapeHtml(card.unit)}</small>
            </div>
          </div>
          <div class="water-report__scale" aria-hidden="true">
            <span class="water-report__scale-segment"></span>
            <span class="water-report__scale-segment"></span>
            <span class="water-report__scale-segment"></span>
            <span class="water-report__scale-segment"></span>
            <span class="water-report__scale-segment"></span>
            <span class="water-report__scale-marker" style="--marker-position: ${position}%"></span>
          </div>
          <div class="water-report__scale-labels">
            <span>0</span>
            <span>${this.escapeHtml(limitLabel)}</span>
          </div>
          <p class="water-report__parameter-description">${this.escapeHtml(card.description)}</p>
          <p class="water-report__parameter-meta">${this.escapeHtml(this.formatDate(card.date))}</p>
        </article>
      `;
    }

    renderDetectedDetails() {
      if (!this.detailsTabs || !this.detailsPanel) return;

      const detected = this.report?.detected || [];
      this.detectedByCategory = detected.reduce((groups, item) => {
        if (!groups[item.category]) groups[item.category] = [];
        groups[item.category].push(item);
        return groups;
      }, { all: detected });
      const categories = [
        { key: 'all', label: this.labels.details_all },
        ...CATEGORY_DEFINITIONS.filter(
          (category) => this.detectedByCategory[category.key]?.length
        ).map((category) => ({
          ...category,
          label: this.labels[category.labelKey],
        })),
      ];

      if (detected.length === 0) {
        this.activeDetailsCategory = '';
        this.detailsTabs.replaceChildren();
        this.detailsTabs.hidden = true;
        this.detailsPanel.setAttribute('role', 'status');
        this.detailsPanel.removeAttribute('aria-labelledby');
        this.detailsPanel.innerHTML = `
          <p class="water-report__empty-findings">${this.escapeHtml(this.labels.no_detected)}</p>
        `;
        return;
      }

      if (!categories.some((category) => category.key === this.activeDetailsCategory)) {
        this.activeDetailsCategory = 'all';
      }

      this.detailsTabs.hidden = false;
      this.detailsPanel.setAttribute('role', 'tabpanel');
      const sectionId = String(this.config.sectionId || 'water-report').replace(/[^a-zA-Z0-9_-]/g, '-');
      this.detailsTabs.innerHTML = categories
        .map((category) => {
          const selected = category.key === this.activeDetailsCategory;
          return `
            <button
              class="water-report__details-tab${selected ? ' is-active' : ''}"
              id="WaterReportTab-${sectionId}-${category.key}"
              type="button"
              role="tab"
              aria-selected="${selected ? 'true' : 'false'}"
              aria-controls="WaterReportDetails-${sectionId}"
              tabindex="${selected ? '0' : '-1'}"
              data-details-category="${category.key}"
            >
              <span>${this.escapeHtml(category.label)}</span>
              <strong>${this.formatNumber(this.detectedByCategory[category.key].length, 0)}</strong>
            </button>
          `;
        })
        .join('');

      this.activateDetailsCategory(this.activeDetailsCategory, { focus: false });
    }

    activateDetailsCategory(categoryKey, { focus = false } = {}) {
      const items = this.detectedByCategory?.[categoryKey];
      const tab = this.detailsTabs?.querySelector(`[data-details-category="${categoryKey}"]`);
      if (!items?.length || !(tab instanceof HTMLButtonElement) || !this.detailsPanel) return;

      this.activeDetailsCategory = categoryKey;
      this.detailsTabs.querySelectorAll('[role="tab"]').forEach((button) => {
        const selected = button === tab;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        button.tabIndex = selected ? 0 : -1;
      });

      this.detailsPanel.setAttribute('aria-labelledby', tab.id);
      this.detailsPanel.innerHTML = `
        <div class="water-report__details-list" role="table">
          <div class="water-report__details-list-head" role="row">
            <span role="columnheader">${this.escapeHtml(this.labels.details_substance_label)}</span>
            <span role="columnheader">${this.escapeHtml(this.labels.details_value_label)}</span>
            <span role="columnheader">${this.escapeHtml(this.labels.details_status_label)}</span>
          </div>
          ${items
            .map((item) => {
              const isConcern = ['pfas', 'pesticides', 'metals', 'disinfection'].includes(item.category);
              const rowClass = [
                item.overLimit ? 'is-over' : '',
                isConcern ? 'is-concern' : '',
              ]
                .filter(Boolean)
                .join(' ');

              return `
                <div class="water-report__details-row${rowClass ? ` ${rowClass}` : ''}" role="row">
                  <span role="cell">${this.escapeHtml(this.sentenceCase(item.name))}</span>
                  <strong role="cell">${this.escapeHtml(this.formatMeasurement(item.value, item.unit))}</strong>
                  <em role="cell">
                    ${this.escapeHtml(
                      item.overLimit ? this.labels.details_status_over : this.labels.details_status_measured
                    )}
                  </em>
                </div>
              `;
            })
            .join('')}
        </div>
      `;

      if (focus) tab.focus();
    }

    handleDetailsTabClick(event) {
      const tab = event.target.closest('[data-details-category]');
      if (!(tab instanceof HTMLButtonElement)) return;
      this.activateDetailsCategory(tab.dataset.detailsCategory || '', { focus: false });
    }

    handleDetailsTabKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      const tabs = Array.from(this.detailsTabs?.querySelectorAll('[role="tab"]') || []);
      const currentIndex = tabs.indexOf(event.target);
      if (currentIndex < 0 || tabs.length === 0) return;

      event.preventDefault();
      let nextIndex = currentIndex;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;

      const nextTab = tabs[nextIndex];
      this.activateDetailsCategory(nextTab.dataset.detailsCategory || '', { focus: true });
    }

    renderRecommendations() {
      if (!this.recommendations || !this.recommendationList) return;

      const concerns = this.report?.concerns || [];
      const concernKeys = new Set(concerns.map((concern) => concern.key));
      const recommendations = Array.isArray(this.config.recommendations) ? this.config.recommendations : [];
      let matched = recommendations.filter(
        (recommendation) =>
          !recommendation.fallback &&
          Object.entries(recommendation.triggers || {}).some(
            ([key, enabled]) => enabled && concernKeys.has(key)
          )
      );

      if (matched.length === 0) {
        matched = recommendations.filter((recommendation) => recommendation.fallback);
      }

      if (matched.length === 0) {
        matched = recommendations;
      }

      matched = matched.slice(0, 3);
      if (matched.length === 0) {
        this.recommendations.hidden = true;
        this.recommendationList.replaceChildren();
        return;
      }

      this.recommendations.hidden = false;
      if (this.recommendationsHeading) {
        const city = this.titleCase(this.current.commune?.nom || '');
        const baseHeading = this.recommendationsHeading.textContent.split(' — ')[0];
        this.recommendationsHeading.textContent = city ? `${baseHeading} — ${city}` : baseHeading;
      }

      this.recommendationList.innerHTML = matched
        .map((recommendation, index) => this.getRecommendationMarkup(recommendation, index, concerns))
        .join('');

      this.recommendationList.querySelectorAll('[data-recommendation-link]').forEach((link) => {
        link.addEventListener('click', () => {
          this.track('rapport_eau_reco_click', {
            ...this.getAnalyticsPayload(),
            product: link.dataset.productHandle || '',
          });
        });
      });
    }

    getRecommendationMarkup(recommendation, index, concerns) {
      const matchedReasons = concerns.filter((concern) => recommendation.triggers?.[concern.key]);
      const claims = String(recommendation.claimsRaw || '')
        .split(/\r?\n/)
        .map((claim) => claim.trim())
        .filter(Boolean);
      const reasonsMarkup = matchedReasons.length
        ? `
          <ul class="water-report__recommendation-reasons">
            ${matchedReasons
              .map(
                (reason) => `
                  <li>${this.escapeHtml(reason.label)}${reason.value ? ` · ${this.escapeHtml(reason.value)}` : ''}</li>
                `
              )
              .join('')}
          </ul>
        `
        : '';
      const claimsMarkup = claims.length
        ? `
          <ul class="water-report__recommendation-claims">
            ${claims.map((claim) => `<li>${this.escapeHtml(claim)}</li>`).join('')}
          </ul>
        `
        : '';
      const productTitle = this.titleCase(recommendation.title);
      const imageMarkup = recommendation.image
        ? `
          <img
            class="water-report__recommendation-image"
            src="${this.escapeAttribute(recommendation.image)}"
            alt="${this.escapeAttribute(recommendation.imageAlt || recommendation.title)}"
            loading="lazy"
            width="1000"
            height="1000"
          >
        `
        : `<span class="water-report__recommendation-placeholder">${this.escapeHtml(productTitle)}</span>`;
      const productUrl = this.buildProductUrl(recommendation.url, concerns);
      const ctaLabel = recommendation.ctaLabel || this.labels.view_product;
      const comparisonBefore = Math.max(0, Math.min(100, Number(recommendation.comparison?.before)));
      const comparisonAfter = Math.max(0, Math.min(100, Number(recommendation.comparison?.after)));
      const showComparison =
        recommendation.comparison?.enabled &&
        Number.isFinite(comparisonBefore) &&
        Number.isFinite(comparisonAfter) &&
        comparisonAfter > comparisonBefore;
      const comparisonBeforeLabel = recommendation.comparison?.beforeLabel || 'Sans Euroguard';
      const comparisonAfterLabel = recommendation.comparison?.afterLabel || 'Avec Euroguard';
      const comparisonMarkup = showComparison
        ? `
          <div
            class="water-report__comparison"
            role="img"
            aria-label="${this.escapeAttribute(
              `${comparisonBeforeLabel} : ${this.formatNumber(comparisonBefore, 0)}. ${comparisonAfterLabel} : ${this.formatNumber(
                comparisonAfter,
                0
              )}.`
            )}"
            style="
              --comparison-before: ${comparisonBefore}%;
              --comparison-after: ${comparisonAfter}%;
              --comparison-range: ${comparisonAfter - comparisonBefore}%;
            "
          >
            <div class="water-report__comparison-track" aria-hidden="true">
              <span class="water-report__comparison-range"></span>
              <span class="water-report__comparison-point water-report__comparison-point--before">
                <strong>${this.formatNumber(comparisonBefore, 0)}</strong>
                <small>${this.escapeHtml(comparisonBeforeLabel)}</small>
              </span>
              <span class="water-report__comparison-point water-report__comparison-point--after">
                <strong>${this.formatNumber(comparisonAfter, 0)}</strong>
                <small>${this.escapeHtml(comparisonAfterLabel)}</small>
              </span>
            </div>
          </div>
        `
        : '';

      return `
        <article class="water-report__recommendation-card">
          <div class="water-report__recommendation-media">${imageMarkup}</div>
          <div class="water-report__recommendation-content">
            ${index === 0 ? `<span class="water-report__primary-badge">${this.escapeHtml(this.labels.primary_label)}</span>` : ''}
            <h3 class="water-report__recommendation-title">${this.escapeHtml(productTitle)}</h3>
            <p class="water-report__recommendation-description">${this.escapeHtml(recommendation.description)}</p>
            ${reasonsMarkup}
            ${claimsMarkup}
            ${comparisonMarkup}
            <div class="water-report__recommendation-footer">
              <span class="water-report__recommendation-price">${this.escapeHtml(recommendation.price)}</span>
              <a
                class="water-report__recommendation-link"
                href="${this.escapeAttribute(productUrl)}"
                data-recommendation-link
                data-product-handle="${this.escapeAttribute(recommendation.handle || '')}"
              >
                ${this.escapeHtml(ctaLabel)}
              </a>
            </div>
          </div>
        </article>
      `;
    }

    buildProductUrl(rawUrl, concerns) {
      const url = new URL(rawUrl || '/', window.location.origin);
      url.searchParams.set('utm_source', 'rapport-eau');
      url.searchParams.set('utm_medium', 'widget');
      url.searchParams.set('utm_campaign', `cp-${this.current.postcode}`);
      url.searchParams.set('cp', this.current.postcode);
      url.searchParams.set('eg_concerns', concerns.map((concern) => concern.key).join(','));
      return url.toString();
    }

    handleResetClick() {
      this.resetInterface({ preservePostcode: false });
      this.postcodeInput?.focus();
      this.scrollIntoView({ behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    resetInterface({ preservePostcode = false } = {}) {
      this.abortActiveRequest();
      this.current = {
        postcode: '',
        commune: null,
        network: null,
      };
      this.report = null;
      this.unlocked = false;
      this.communes = [];
      this.networks = [];
      this.detectedByCategory = {};
      this.activeDetailsCategory = '';

      if (!preservePostcode && this.postcodeInput) this.postcodeInput.value = '';
      if (this.communePicker) this.communePicker.hidden = true;
      if (this.networkPicker) this.networkPicker.hidden = true;
      if (this.emailGate) this.emailGate.hidden = true;
      if (this.results) this.results.hidden = true;
      if (this.emailForm) this.emailForm.reset();
      if (this.parameterGrid) this.parameterGrid.replaceChildren();
      if (this.detailsTabs) this.detailsTabs.replaceChildren();
      if (this.detailsPanel) {
        this.detailsPanel.replaceChildren();
        this.detailsPanel.setAttribute('role', 'tabpanel');
        this.detailsPanel.removeAttribute('aria-labelledby');
      }
      if (this.recommendationList) this.recommendationList.replaceChildren();
      if (this.recommendations) this.recommendations.hidden = true;

      this.hideProgress();
      this.hideError();
      this.hideGateMessages();
      this.setSearchBusy(false);
      this.setGateBusy(false);
    }

    abortActiveRequest() {
      if (this.requestController) {
        this.requestController.abort();
        this.requestController = null;
      }
    }

    async fetchJson(url, parentSignal) {
      const timeoutController = new AbortController();
      let timedOut = false;
      const timeoutId = window.setTimeout(() => {
        timedOut = true;
        timeoutController.abort();
      }, REQUEST_TIMEOUT);
      const abortFromParent = () => timeoutController.abort();

      if (parentSignal) {
        if (parentSignal.aborted) timeoutController.abort();
        else parentSignal.addEventListener('abort', abortFromParent, { once: true });
      }

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
          cache: 'no-store',
          signal: timeoutController.signal,
        });

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        return await response.json();
      } catch (error) {
        if (timedOut && !parentSignal?.aborted) {
          throw new Error('Request timed out');
        }
        throw error;
      } finally {
        window.clearTimeout(timeoutId);
        parentSignal?.removeEventListener('abort', abortFromParent);
      }
    }

    async fetchWithTimeout(url, options = {}) {
      const controller = new AbortController();
      const timeoutId = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT);

      try {
        return await fetch(url, {
          ...options,
          signal: controller.signal,
        });
      } finally {
        window.clearTimeout(timeoutId);
      }
    }

    setProgress(stage, message) {
      const stageOrder = ['commune', 'network', 'results'];
      const activeIndex = stageOrder.indexOf(stage);

      if (this.progress) this.progress.hidden = false;
      if (this.progressText) this.progressText.textContent = message;
      this.progressSteps.forEach((step) => {
        const stepIndex = stageOrder.indexOf(step.dataset.progressStep || '');
        const isComplete = activeIndex > stepIndex;
        const isActive = activeIndex === stepIndex;

        step.classList.toggle('is-complete', isComplete);
        step.classList.toggle('is-active', isActive);
        if (isActive) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
      this.announce(message);
    }

    hideProgress() {
      if (this.progress) this.progress.hidden = true;
      if (this.progressText) this.progressText.textContent = '';
      this.progressSteps.forEach((step) => {
        step.classList.remove('is-complete', 'is-active');
        step.removeAttribute('aria-current');
      });
    }

    setSearchBusy(isBusy) {
      if (this.searchButton) {
        this.searchButton.disabled = isBusy;
        this.searchButton.textContent = isBusy ? this.labels.search_loading : this.labels.search_button;
      }
      if (this.postcodeInput) {
        this.postcodeInput.disabled = isBusy;
        this.postcodeInput.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      }
      this.exampleButtons.forEach((button) => {
        button.disabled = isBusy;
      });
    }

    setGateBusy(isBusy) {
      if (this.emailSubmit) {
        this.emailSubmit.disabled = isBusy;
        this.emailSubmit.textContent = isBusy ? this.labels.gate_saving : this.labels.gate_button;
      }
      if (this.emailInput) this.emailInput.disabled = isBusy;
      if (this.consentInput) this.consentInput.disabled = isBusy;
      if (this.previewBypass) this.previewBypass.disabled = isBusy;
    }

    showError(message, code) {
      this.hideProgress();
      this.setSearchBusy(false);
      if (this.errorBox) {
        this.errorBox.textContent = message;
        this.errorBox.hidden = false;
      }
      this.announce(message);
      this.track('rapport_eau_error', {
        stage: 'report',
        code,
        postcode: this.current.postcode || String(this.postcodeInput?.value || '').trim(),
      });
    }

    hideError() {
      if (!this.errorBox) return;
      this.errorBox.hidden = true;
      this.errorBox.textContent = '';
    }

    showGateError(message) {
      if (this.gateError) {
        this.gateError.textContent = message;
        this.gateError.hidden = false;
      }
      if (this.gateSuccess) this.gateSuccess.hidden = true;
      this.announce(message);
    }

    showGateSuccess(message) {
      if (this.gateSuccess) {
        this.gateSuccess.textContent = message;
        this.gateSuccess.hidden = false;
      }
      if (this.gateError) this.gateError.hidden = true;
      this.announce(message);
    }

    hideGateMessages() {
      if (this.gateError) {
        this.gateError.hidden = true;
        this.gateError.textContent = '';
      }
      if (this.gateSuccess) {
        this.gateSuccess.hidden = true;
        this.gateSuccess.textContent = '';
      }
    }

    announce(message) {
      if (!this.liveRegion) return;
      this.liveRegion.textContent = '';
      window.requestAnimationFrame(() => {
        this.liveRegion.textContent = message || '';
      });
    }

    resolveConformity(values) {
      const normalized = values.map((value) => String(value || '').toUpperCase()).filter(Boolean);
      if (normalized.includes('N')) return 'N';
      if (normalized.includes('C')) return 'C';
      return null;
    }

    getParameterKey(row) {
      return row?.code_parametre_se || row?.code_parametre || row?.libelle_parametre_maj || row?.libelle_parametre || '';
    }

    getDataWindowMonths() {
      const months = Number(this.config.months);
      return Number.isFinite(months) ? Math.max(3, Math.min(24, months)) : 12;
    }

    getAnalyticsPayload() {
      return {
        postcode: this.current.postcode,
        commune: this.current.commune?.nom || '',
        network: this.report?.networkName || '',
        detected: this.report?.detected.length || 0,
        concerns: (this.report?.concerns || []).map((concern) => concern.key).join(','),
        conforming: Boolean(this.report?.isConforming),
      };
    }

    track(eventName, properties = {}) {
      if (!Array.isArray(window.dataLayer)) return;
      window.dataLayer.push({
        event: eventName,
        ...properties,
      });
    }

    parseLimit(value) {
      if (value == null || value === '') return null;
      const match = String(value).replace(',', '.').match(/-?\d+(?:\.\d+)?/);
      return match ? Number(match[0]) : null;
    }

    toNumber(value) {
      if (typeof value === 'number' && Number.isFinite(value)) return value;
      if (value == null || value === '') return null;

      const number = Number(String(value).replace(',', '.'));
      return Number.isFinite(number) ? number : null;
    }

    timestamp(value) {
      const timestamp = Date.parse(value || '');
      return Number.isFinite(timestamp) ? timestamp : 0;
    }

    formatDate(value) {
      if (!value) return '—';

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);

      return new Intl.DateTimeFormat('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }).format(date);
    }

    formatNumber(value, maximumFractionDigits = 3) {
      return new Intl.NumberFormat('fr-FR', {
        maximumFractionDigits,
      }).format(Number(value) || 0);
    }

    formatMeasurement(value, unit) {
      const normalizedUnit = String(unit || '').trim();
      return `${this.formatNumber(value)}${normalizedUnit ? ` ${normalizedUnit}` : ''}`;
    }

    titleCase(value) {
      return String(value || '')
        .toLocaleLowerCase('fr-FR')
        .replace(
          /(^|[\s'-])(\p{L})/gu,
          (match, separator, letter) => `${separator}${letter.toLocaleUpperCase('fr-FR')}`
        )
        .replace(
          /([\s-])(De|Du|Des|La|Le|Les|Sur|Sous|En|Et)(?=[\s-]|$)/gu,
          (match, separator, word) => `${separator}${word.toLocaleLowerCase('fr-FR')}`
        )
        .replace(
          /([\s-])(D|L)'/gu,
          (match, separator, prefix) => `${separator}${prefix.toLocaleLowerCase('fr-FR')}'`
        )
        .replace(/\bpfas\b/giu, 'PFAS')
        .replace(/\bpfoa\b/giu, 'PFOA')
        .replace(/\bpfos\b/giu, 'PFOS');
    }

    sentenceCase(value) {
      const normalized = String(value || '').trim().toLocaleLowerCase('fr-FR');
      if (!normalized) return '';

      return normalized
        .replace(/(^|[.!?]\s+)(\p{L})/gu, (match, prefix, letter) => `${prefix}${letter.toLocaleUpperCase('fr-FR')}`)
        .replace(/\bpfas\b/giu, 'PFAS')
        .replace(/\bpfoa\b/giu, 'PFOA')
        .replace(/\bpfos\b/giu, 'PFOS')
        .replace(/\b(?:esa|oxa|ampa)\b/giu, (match) => match.toLocaleUpperCase('fr-FR'))
        .replace(/\b(\p{L})(\d{2,})\b/gu, (match, letter, digits) => `${letter.toLocaleUpperCase('fr-FR')}${digits}`)
        .replace(/\bcvm\b/giu, 'CVM')
        .replace(/\bthm\b/giu, 'THM');
    }

    parameterTitle(value, key) {
      const title = this.sentenceCase(value);
      if (key === 'pfas') return 'PFAS';
      return title;
    }

    prefersReducedMotion() {
      return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    }

    isAbortError(error) {
      return error?.name === 'AbortError';
    }

    escapeHtml(value) {
      return String(value ?? '').replace(/[&<>"']/g, (character) => {
        const entities = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;',
        };
        return entities[character];
      });
    }

    escapeAttribute(value) {
      return this.escapeHtml(value);
    }
  }

  customElements.define('water-report', WaterReport);
})();
